<template>
  <div class="panel-wrapper">
    <!-- 列表头部 -->
    <div class="com-list-header" style="paddingRight: 0;padding-bottom: 10px;display: flex">
      <div>
        <span class="time" :class="{'active': item.dictCode == selectedTime}" @click="changeTimeType(item)" v-for="item in timeArr" :key="item.dictCode">{{item.dictName}} </span>
      </div>

      <el-form class="com-search-box" ref="form" :model="form" label-width="60px">
        <el-form-item label="时间 :" prop="queryTime">
          <el-date-picker v-model="form.queryTime" :format="format" :value-format="format" type="date" placeholder="请选择"></el-date-picker>
        </el-form-item>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <div class="com-list-content">
      <div class="content-list">
        <div class="box">
          <p class="text m-b">新增图书（本）</p>
          <p class="text font-36">{{bookNumObj.addBook ? bookNumObj.addBook : 0}}</p>
        </div>

        <div class="box">
          <p class="text m-b">借阅次数（人）</p>
          <p class="text font-36">{{bookNumObj.borrowNo ? bookNumObj.borrowNo : 0}}</p>
        </div>

        <div class="box">
          <p class="text m-b">还书人数（人）</p>
          <p class="text font-36">{{bookNumObj.return ? bookNumObj.return : 0}}</p>
        </div>

        <div class="box">
          <p class="text m-b">逾期未还（人）</p>
          <p class="text font-36">{{bookNumObj.over ? bookNumObj.over : 0}}</p>
        </div>

        <div class="box">
          <p class="text m-b">借出图书（本）</p>
          <p class="text font-36">{{bookNumObj.borrowBook ? bookNumObj.borrowBook : 0}}</p>
        </div>

        <div class="box">
          <p class="text m-b">图书总数（本）</p>
          <p class="text font-36">{{bookNumObj.bookTotal ? bookNumObj.bookTotal : 0}}</p>
        </div>

        <div class="box">
          <p class="text m-b">期刊总数（本）</p>
          <p class="text font-36">{{bookNumObj.periodicalTotal ? bookNumObj.periodicalTotal : 0}}</p>
        </div>

        <div class="box">
          <p class="text m-b">出版物总数（本）</p>
          <p class="text font-36">{{bookNumObj.publicationTotal ? bookNumObj.publicationTotal : 0}}</p>
        </div>
      </div>

      <div class="chart-wrapper">

        <div class="chart-item">
          <el-empty style="width: 100%;height: 100%;"  v-if="!loading1 && chart1Arr.length <= 0" description="暂无数据"></el-empty>

          <div class="h-100" v-else>
            <h1 class="title">图书分类统计</h1>
            <chart v-loading="loading1" ref="chart1" :options="options1" style="width: 100%;height: 100%;" :auto-resize="true"></chart>
          </div>
        </div>
        <div class="chart-item">
          <el-empty style="width: 100%;height: 100%;"  v-if="!loading2 && chart2Arr.length <= 0" description="暂无数据"></el-empty>
          <div  class="h-100" v-else>
            <h1 class="title">热门借阅分类统计</h1>
            <chart ref="chart2" :options="options2" style="width: 100%;height: 100%;" :auto-resize="true"></chart>
          </div>
        </div>
      </div>
      <div class="chart-wrapper">
        <div class="chart-item">
          <el-empty style="width: 100%;height: 100%;"  v-if="!loading3 && chart3Arr.length <= 0" description="暂无数据"></el-empty>
          <div  class="h-100" v-else>
            <h1 class="title">图书排名</h1>
            <chart ref="chart3" :options="options3" style="width: 100%;height: 100%;" :auto-resize="true"></chart>
          </div>
        </div>
        <div class="chart-item">
          <el-empty style="width: 100%;height: 100%;"  v-if="!loading4 && chart4Arr.length <= 0" description="暂无数据"></el-empty>
          <div  class="h-100" v-else>
            <h1 class="title">读者排名</h1>
            <chart ref="chart4" :options="options4" style="width: 100%;height: 100%;" :auto-resize="true"></chart>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import chart from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/bar'

import 'echarts/lib/component/title' //引入标题组件
import 'echarts/lib/component/legend' //引入图例组件
import 'echarts/lib/component/tooltip' //引入图例组件
import 'echarts/lib/component/toolbox' //引入图例组件
import 'echarts/lib/component/dataZoom' // 滚动条插件
export default {
  components: {
    chart,
  },
  data() {
    return {
      form: {
        queryTime: ""
      },
      loading1: false,
      chart1Arr: [],

      loading2: false,
      chart2Arr: [],

      loading3: false,
      chart3Arr: [],

      loading4: false,
      chart4Arr: [],
      bookNumObj: {},
      format: 'yyyy-MM-dd',
      selectedTime: 'year',
      timeArr: [{ dictCode: 'date', dictName: '日' },
      { dictCode: 'week', dictName: '周' },
      { dictCode: 'month', dictName: '月' },
      { dictCode: 'year', dictName: '年' }],

      options1: {},
      options2: {},
      options3: {},
      options4: {},

    }
  },
  methods: {
    changeTimeType(obj) {
      this.selectedTime = obj.dictCode
      this.form.queryTime = ""
      this.getPanelTotal()
    },

    getTableList() {
      this.getPanelTotal()
    },
    restList() {
      this.changeTimeType({ dictCode: 'date' })
      this.getPanelTotal()
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      return new Promise((resolve, reject) => {
        this.$http.get('/collectDict/getSelectDataByKey', {
          key: 'book_type'
        }).then(res => {
          if (res.success) {
            resolve(res.result)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },

    getPanelTotal() {
      this.bookNumObj = {}
      //this.selectedTime == 'date' ? 'day' : this.selectedTime
      let param = {
        offset: this.selectedTime == 'date' ? 'day' : this.selectedTime,
        data: this.form.queryTime
      }
      this.$api.book.getPanelTotal(param).then(res => {
        if (res.success) {
          let results = res.result
          this.bookNumObj = results
        }
      })

      this.getChartOne(param)

      this.getChartTwo(param)

      this.getChartThree(param)

      this.getChartFour(param)

    },

    getChartOne(param) {
      this.loading1 = true
      this.chart1Arr = []
      this.$api.book.getPanelChartOne(param).then(res => {
        this.loading1 = false
        if (res.success) {
          let results = res.result, pieArr = [], names = []
          if (results && results.length > 0) {
            this.bookTypeList.map(item => {
              results.map(it => {
                if (it.book_type.toUpperCase() == item.dictCode) {
                  it.bookName = item.dictName
                }
              })
            })

            results.map(item => {
              let obj = new Object()
              obj.name = item.bookName
              obj.value = item.num
              pieArr.push(obj)
              names.push(item.bookName)
            })

            this.chart1Arr = results

            let option = {
              tooltip: {
                trigger: 'item',
              },
              legend: {
                orient: 'horizontal',
                bottom: '20',
                data: names
              },
              series: [
                {
                  type: 'pie',
                  radius: '50%',
                  label: {
                    formatter: '{b}: {d}%'
                  },
                  data: pieArr,
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  }
                }
              ]
            };

            this.options1 = option
          }
        }
      })
    },

    getChartTwo(param) {
      this.loading2 = true
      this.chart2Arr = []
      this.$api.book.getPanelChartTwo(param).then(res => {
        this.loading2 = false

        if (res.success) {
          let results = res.result, barArr = [], names = []
          if (results && results.length > 0) {
            this.bookTypeList.map(item => {
              results.map(it => {
                if (it.book_type.toUpperCase() == item.dictCode) {
                  it.bookName = item.dictName
                }
              })
            })

            results.map(item => {
              let obj = new Object()
              obj.name = item.bookName
              obj.value = item.num
              barArr.push(obj)
              names.push(item.bookName)
            })

            this.chart2Arr = results

            let option2 = {
              xAxis: {
                type: 'category',
                data: names
              },
              yAxis: {
                type: 'value'
              },
              color: ['#018F78'],
              series: [
                {
                  data: barArr,
                  barWidth: 30,
                  type: 'bar'
                }
              ]
            };
            this.options2 = option2
          }
        }
      })
    },

    getChartThree(param) {
      this.loading3 = true
      this.chart3Arr = []
      this.$api.book.getPanelChartThree(param).then(res => {
        this.loading3 = false

        if (res.success) {
          let results = res.result, barArr = [], names = []
          if (results && results.length > 0) {
            this.bookTypeList.map(item => {
              results.map(it => {
                if (it.book_type.toUpperCase() == item.dictCode) {
                  it.bookName = item.dictName
                }
              })
            })

            results.map(item => {
              let obj = new Object()
              obj.name = item.bookName
              obj.value = item.num
              barArr.push(obj)
              names.push(item.bookName)
            })

            this.chart3Arr = results
            let option = {
              xAxis: {
                type: 'category',
                data: names
              },
              yAxis: {
                type: 'value'
              },
              color: ['#018F78'],
              series: [
                {
                  barWidth: 30,
                  data: barArr,
                  type: 'bar'
                }
              ]
            };
            this.options3 = option
          }
        }
      })
    },

    getChartFour(param) {
      this.loading4 = true
      this.chart4Arr = []
      this.$api.book.getPanelChartFour(param).then(res => {
        this.loading4 = false

        if (res.success) {
          let results = res.result, barArr = [], names = []
          if (results && results.length > 0) {
            results.map(item => {
              let obj = new Object()
              obj.name = item.userName
              obj.value = item.num
              barArr.push(obj)
              names.push(item.userName)
            })

            this.chart4Arr = results

            let option = {
              xAxis: {
                type: 'category',
                data: names
              },
              yAxis: {
                type: 'value'
              },
              color: ['#018F78'],
              series: [
                {
                  barWidth: 30,
                  data: barArr,
                  type: 'bar'
                }
              ]
            };
            this.options4 = option
          }
        }
      })
    }
  },


  async mounted() {
    this.bookTypeList = await this.getDropdownValue()
    this.getPanelTotal()
  }
}
</script>

<style lang='scss' scoped>
.panel-wrapper {
  .time {
    display: inline-block;
    width: 70px;
    text-align: center;
    margin-right: 20px;
    padding: 5px 10px;
    height: 40px;
    line-height: 25px;
    box-sizing: border-box;
    border: 1px solid #ebedf2;
    border-radius: 2px;
    cursor: pointer;
    &.active {
      background: #ff0033;
      color: #fff;
    }
  }

  .com-list-content {
    .content-list {
      display: flex;
      gap: 25px;
      flex-wrap: wrap;
      .box {
        width: 207px;
        height: 125px;
        box-sizing: border-box;
        background-color: $primary;
        border-radius: 3px;
        padding: 20px;
        .text {
          font-weight: 400;
          font-style: normal;
          font-size: 18px;
          color: #ffffff;
          &.font-36 {
            font-size: 36px;
          }

          &.m-b {
            margin-bottom: 8px;
          }
        }
      }
    }

    .chart-wrapper {
      display: flex;
      gap: 20px;
      margin-top: 20px;
      .chart-item {
        width: 100%;
        height: 600px;
        flex: 1;
        border: 1px solid rgba(215, 215, 215, 1);
        position: relative;
        .title {
          position: absolute;
          top: 20px;
          left: 20px;
        }
      }
    }
  }
}
</style>